import { request } from '@umijs/max';

type RequestOptions = Record<string, unknown>;

export async function listNotifications(
  params: API.NotificationListQuery,
  options?: RequestOptions,
) {
  return request<API.Response<API.NotificationListResponse>>(
    '/api/internal/notifications',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function getUnreadNotificationCount(options?: RequestOptions) {
  return request<API.Response<API.UnreadCountResponse>>(
    '/api/internal/notifications/unread-count',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

export async function markNotificationRead(id: number, options?: RequestOptions) {
  return request<API.Response<null>>(`/api/internal/notifications/${id}/read`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function markAllNotificationsRead(options?: RequestOptions) {
  return request<API.Response<null>>('/api/internal/notifications/read-all', {
    method: 'POST',
    ...(options || {}),
  });
}

export async function listExceptions(
  params: API.ExceptionListQuery,
  options?: RequestOptions,
) {
  return request<API.Response<API.ExceptionListResponse>>(
    '/api/internal/exceptions',
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

export async function handleException(
  id: number,
  body: API.ExceptionActionRequest,
  options?: RequestOptions,
) {
  return request<API.Response<null>>(`/api/internal/exceptions/${id}/handle`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function ignoreException(
  id: number,
  body: API.ExceptionActionRequest,
  options?: RequestOptions,
) {
  return request<API.Response<null>>(`/api/internal/exceptions/${id}/ignore`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}
